// The three calculation systems, as [value, label] selector pairs.

export const SYSTEMS: Array<[string, string]> = [
  ['drik', 'Drik Ganita'],
  ['surya-siddhanta', 'Surya Siddhanta'],
  ['vakya', 'Vakya'],
];
